import React from "react"
import { CaseRateRenewalModalTopSection } from "./CaseRateRenewalModalTopSection"
import { CaseRateRenewalModalButtonGroup } from "./CaseRateRenewalModalButtonGroup"
import { FormattedMessage, useIntl } from "react-intl"
import { Button, Typography } from "@carrotfertility/carotene-core"
import { useIsMemberInSensitiveState } from "#/components/carrot-plans/hooks/useIsMemberInSensitiveState"

type DoneForNowContentProps = {
  takeMeBackOnClick: () => void
  yesImDoneOnClick: () => void
  isLoading: boolean
}

export function DoneForNowContent({
  takeMeBackOnClick,
  yesImDoneOnClick,
  isLoading
}: DoneForNowContentProps): JSX.Element {
  const intl = useIntl()
  const isMemberInSensitiveState = useIsMemberInSensitiveState()

  return (
    <>
      <CaseRateRenewalModalTopSection
        header={intl.formatMessage({
          defaultMessage: "Are you sure you're done using Carrot?"
        })}
        showImage
        imageAltText=""
        imageSrc="/images/illo-underwater-glass"
      />
      <Typography variant="body1" color={(theme) => theme.palette.text.secondary}>
        {isMemberInSensitiveState ? (
          <FormattedMessage defaultMessage="If you’re done, you will not have access to your funds, Provider finder, or specialist chats, and your Carrot Companion will be unassigned. You can get full access to your benefit and a dedicated Carrot Companion by requesting a new plan." />
        ) : (
          <FormattedMessage defaultMessage="If you’re done, your Carrot Plan will disappear, you will not have access to funds or specialist chats, and your Carrot Companion will be unassigned. You can get full access to your benefit and a dedicated Carrot Companion by requesting a new plan." />
        )}
      </Typography>
      <CaseRateRenewalModalButtonGroup
        buttonOne={
          <Button variant="outlined" color="inherit" onClick={takeMeBackOnClick} disabled={isLoading}>
            <FormattedMessage defaultMessage="No, take me back" />
          </Button>
        }
        buttonTwo={
          <Button variant="contained" onClick={yesImDoneOnClick} disabled={isLoading}>
            <FormattedMessage defaultMessage="Yes, I'm done" />
          </Button>
        }
      />
    </>
  )
}
